import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import {HashRouter, Route, Switch} from 'react-router-dom';
import * as serviceWorker from './serviceWorker';
import "@amzn/meridian-tokens/base/font/amazon-ember.css";
import Stage from "./components/stageStatus/Stage";
import Associates from "./components/stageassociate/Associates";
import CartDetailComponent from "./components/cartDrillDown/CartDetailComponent";
import Depart from "./components/depart/Depart";
import {addLocaleData, IntlProvider} from 'react-intl';
import en from 'react-intl/locale-data/en'
import ja from 'react-intl/locale-data/ja'
import it from 'react-intl/locale-data/it'
import fr from 'react-intl/locale-data/fr'
import es from 'react-intl/locale-data/es'
import de from 'react-intl/locale-data/de'
import ar from 'react-intl/locale-data/ar'
import tr from 'react-intl/locale-data/tr'
import {getDirection, getLocale, getMessages} from "./handler/LocaleHandler";
import ErrorBoundary from "./components/handler/ErrorBoundary";
import {Logger} from "./components/util/Logger";
import {DeviceLayoutProvider} from './components/common/context/DeviceLayoutContext';
import blueDarkTokens from "@amzn/meridian-tokens/theme/blue-dark";
import blueLightTokens from "@amzn/meridian-tokens/theme/blue-light";
import Theme from "@amzn/meridian/theme";
import {
  getDarkModeStatus,
  setDarkModeStateListener,
} from "./components/handler/ParentDataHandler";
import { DARK_MODE } from "./components/util/Constants";
addLocaleData(en)
addLocaleData(ja)
addLocaleData(it)
addLocaleData(de)
addLocaleData(fr)
addLocaleData(es)
addLocaleData(ar)
addLocaleData(tr)

getLocale().then(locale => {
    document.getElementsByTagName(`html`)[0].setAttribute("dir", getDirection(locale));
    ReactDOM.render(<GetRouter locale={locale} />, document.getElementById('root'));
})

Logger.initialise();

export const GetRouter = ({locale}) => {
    const [currentDarkMode, setCurrentDarkMode] = useState(DARK_MODE.LIGHT);

    useEffect(() => {
        setDarkModeStateListener(setCurrentDarkMode);
        getDarkModeStatus();
    }, []);

    return (
        <Theme tokens={currentDarkMode === DARK_MODE.DARK ? blueDarkTokens : blueLightTokens} >
            <ErrorBoundary>
                <IntlProvider locale={locale} messages={getMessages(locale)}>
                    <DeviceLayoutProvider>
                        <HashRouter>
                            <Switch>
                                <Route path="/stage/:context" component={Stage} />
                                <Route path="/stage" component={Stage} />
                                <Route path="/stageassociates" component={Associates} />
                                <Route path="/cartDetail/:routeId/:cartId/:status/:location/:associate/:stationCode"
                                    component={CartDetailComponent} />
                                <Route path="/depart/:context" component={Depart} />
                                <Route path="/depart" component={Depart} />
                            </Switch>
                        </HashRouter>
                    </DeviceLayoutProvider>
                </IntlProvider>
            </ErrorBoundary>
        </Theme>
    );
};

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();



// WEBPACK FOOTER //
// ./src/index.js